// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"603ea5c3","331":"30a942c1","422":"ccf10451","960":"38c18d87"}[chunkId] + ".chunk.css";
};